namespace GeniuzPOS.AdvPromo {
    export enum PromoCustFg {
        PromoCustFg = 0,
        PromoCustFg1 = 1,
        PromoCustFg2 = 2,
        PromoCustFg3 = 3
    }
    Serenity.Decorators.registerEnumType(PromoCustFg, 'GeniuzPOS.AdvPromo.PromoCustFg');
}
